module.exports = __webpack_public_path__ + "img/site-selection-new.19ff96f0.svg";